/* eslint-disable @typescript-eslint/no-explicit-any */
export interface IResponse {
      message: string
      data?: any
}

export interface IOTPRequest {
      email: string
      phone: string
}
export enum ERolename {
      user = 'user',
      dl_admin = 'dl_admin',
      department_admin = 'department_admin',
      admin = 'admin',
      test_user = 'test_user',
      verifier = 'verifier'
}
export type User = {
      id: number;
      fullName: string;
      email: string;
      countryCode: string;
      phone: string;
      departmentId: number | null;
      rolename: string;
      status: boolean;
      createdAt: number;
      updatedAt: number;
}
export interface ILogin {
      email: string;
      password: string
}
export interface IResetPassword {
      email: string;
      password: string
      otp: string
}
export interface IRegister {
      fullname?: string
      email?: string
      password?: string
      countryCode?: string
      phone?: string
      otp?: string
      rolename?: ERolename
      confirmPassword?: string
}
interface IRegisterUser {
      user: User
}
export interface IRegisterResponse {
      message: string
      data: IRegisterUser
      token: string
}


export type ILoginResponse = {
      token: string;
      user: User;
}